import { useState } from "react";
import axios from "axios";
import "./VentasUploader.css";
import Swal from 'sweetalert2';

const VentasUploader = () => {
  const [file, setFile] = useState(null);
  const [sucursal, setSucursal] = useState("");
  const [periodoInicio, setPeriodoInicio] = useState("");
  const [periodoFin, setPeriodoFin] = useState("");
  const [categoria, setCategoria] = useState("");
  const [loading, setLoading] = useState(false);

  const enviarXML = async () => {
    if (!file || !sucursal || !categoria) {
      Swal.fire({
        title: 'Campos incompletos',
        text: 'Por favor, completa todos los campos y selecciona un archivo antes de continuar.',
        icon: 'warning',
        confirmButtonText: 'Aceptar',
        showClass: {
          popup: 'animate__animated animate__fadeInDown'
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp'
        }
      });
      return;
    }

    const formatDate = (d) => {
      if (!d) return 'No seleccionado';
      const parts = d.split('-');
      if (parts.length !== 3) return d;
      const [y, m, day] = parts;
      const monthNames = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
      const dayNum = parseInt(day, 10);
      const monthIndex = parseInt(m, 10) - 1;
      const monthName = monthNames[monthIndex] || m;
      return `${dayNum} de ${monthName} de ${y}`;
    };

    const periodoApplicable = ["GP1", "GP2", "GC1", "GC2", "OFERTAS"].includes(categoria);
    const fileName = file && file.name ? file.name : 'Sin archivo seleccionado';
    let confirmHtml = `
      <p><strong>Archivo:</strong> ${fileName}</p>
      <p><strong>Sucursal:</strong> ${sucursal}</p>
      <p><strong>Almacén:</strong> ${categoria}</p>
    `;
    if (periodoApplicable) {
      confirmHtml += `<p><strong>Fecha Inicio:</strong> ${formatDate(periodoInicio)}</p>`;
      confirmHtml += `<p><strong>Fecha Fin:</strong> ${formatDate(periodoFin)}</p>`;
    }

    const result = await Swal.fire({
      title: 'Verifica los datos antes de enviar',
      html: confirmHtml,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Enviar',
      cancelButtonText: 'Editar',
      focusConfirm: false,
      showClass: {
        popup: 'animate__animated animate__fadeInDown'
      },
      hideClass: {
        popup: 'animate__animated animate__fadeOutUp'
      }
    });

    if (!result.isConfirmed) return;

    const formData = new FormData();
    formData.append("file", file);
    formData.append("sucursal", sucursal);
    formData.append("almacen", categoria);
    if (periodoApplicable) {
      if (periodoInicio) formData.append("periodo_inicio", periodoInicio);
      if (periodoFin) formData.append("periodo_fin", periodoFin);
    }

    try {
      setLoading(true);
      await axios.post(`${process.env.REACT_APP_API_URL}/xml/ventas/upload-xml/`, formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
      Swal.fire({
        title: 'XML cargado correctamente',
        text: 'El archivo se ha procesado exitosamente.',
        icon: 'success',
        confirmButtonText: 'Aceptar'
      });
      setFile(null);
      setSucursal("");
      setPeriodoInicio("");
      setPeriodoFin("");
      setCategoria("");
    } catch (error) {
      console.error("Error al cargar el XML:", error);
      Swal.fire({
        title: 'Error al cargar el archivo',
        text: 'Hubo un problema al procesar el archivo XML. Por favor, verifica el formato y vuelve a intentarlo.',
        icon: 'error',
        confirmButtonText: 'Aceptar',
        showClass: {
          popup: 'animate__animated animate__fadeInDown'
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp'
        }
      });
    } finally {
      setLoading(false);
    }
  };

  const almacenes = ["GC1", "GC2", "GP1", "GP2", "OFERTAS", "PD", "PEPSI-COCA"];

  return (
    <div className="ventas-uploader">
      <h2>Subir Ventas del ultimo periodo</h2>
      <label>
        Archivo XML:
        <input type="file" accept=".xml" onChange={(e) => setFile(e.target.files[0])} />
      </label>
      <label>
        Sucursal:
        <input type="text" placeholder="Sucursal" value={sucursal} onChange={(e) => setSucursal(e.target.value)} />
      </label>
      {(categoria === "GP1" || categoria === "GP2" || categoria === "GC1" || categoria === "GC2" || categoria === "OFERTAS") && (
        <>
          <label>
            Fecha Inicio:
            <input type="date" value={periodoInicio} onChange={(e) => setPeriodoInicio(e.target.value)} />
          </label>
          <label>
            Fecha Fin:
            <input type="date" value={periodoFin} onChange={(e) => setPeriodoFin(e.target.value)} />
          </label>
        </>
      )}
      <select
        value={categoria}
        onChange={(e) => setCategoria(e.target.value)}
        required
      >
        <option value="">ALMACEN</option>
        {almacenes.map((alm) => (
          <option key={alm} value={alm}>{alm}</option>
        ))}
      </select>

      {/* <label>
        Almacen:
        <input type="text" placeholder="Almacen" value={categoria} onChange={(e) => setCategoria(e.target.value)} />
      </label>
      <div className="alerta-almacen">
          Ingresa el almacen como: GC1, GC2, GP1, GP2 u OFERTAS
      </div> */}
      <button onClick={enviarXML} disabled={loading}>
        {loading ? "Subiendo..." : "Subir Archivo"}
      </button>
    </div>
  );
};

export default VentasUploader;
